import { Loader2 } from 'lucide-react';

export function Loading({ label = 'Cargando…' }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-3 py-16 text-text-dim">
      <Loader2 size={20} className="animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function PageFallback() {
  return (
    <div className="flex items-center justify-center min-h-[40vh]">
      <Loading />
    </div>
  );
}